// Wrapper del AuthProvider que maneja la navegación
// RecomiendaT - Sistema de recomendaciones

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext';

export default function AuthProviderWrapper({ children }) {
  const navigate = useNavigate();
  
  return (
    <AuthProvider navigate={navigate}>
      {children}
    </AuthProvider>
  );
}
